module.exports = __webpack_public_path__ + "static/pcp-product-f632a8d0a1ea9adde76d13675fd2c35e.png";